import axios from "axios";

export const state = {
    expensecarts: [],
};

export const getters = {
    expensecarts: state => state.expensecarts,
};

export const mutations = {
    setCart(state, newValue) {
        state.expensecarts = newValue
    },
};

export const actions = {
    fetchExpenseCart({ commit }) {
        axios.get('/expensecart').then(res => {
            commit('setCart', res.data.carts);
        })
    },
};
